import { render, staticRenderFns } from "./PameraSafeTask.vue?vue&type=template&id=488d2464&scoped=true&"
import script from "./PameraSafeTask.vue?vue&type=script&lang=js&"
export * from "./PameraSafeTask.vue?vue&type=script&lang=js&"
import style0 from "./PameraSafeTask.vue?vue&type=style&index=0&id=488d2464&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d2464",
  null
  
)

export default component.exports